import { render, staticRenderFns } from "./StepGases.vue?vue&type=template&id=00270188&lang=html&"
import script from "./StepGases.vue?vue&type=script&lang=js&"
export * from "./StepGases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports